import React from 'react';
import CopyIcon from 'pub-components/CopyIcon';
import UniversalModal from 'pub-components/UniversalModal';
import { useSelector } from 'react-redux';
import { getCompanyConfig } from 'store/slices/general/generalSlice';

const ContactModal = ({ show, handleClose }) => {
  const { supportUser } = useSelector(getCompanyConfig);

  return (
    <UniversalModal
      isOpen={show}
      onClose={handleClose}
      size="small"
      dialogClassName={'modal-45w'}
      footerButtons={[
        {
          label: 'Cancel',
          onClick: handleClose,
          className: 'btn-secondary'
        }
      ]}
      title="Contact Us"
    >
      <div class="contact-container">
        <p class="contact-header">
          For any assistance, feel free to contact us!
        </p>
        {supportUser?.Name ? (
          <>
            <div class="contact-item">
              <span class="contact-label">Success Professional Name :</span>
              <span>{supportUser?.Name}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">Success Professional Email :</span>
              <a href={`mailto:${supportUser?.Email}`}>{supportUser?.Email}</a>
              <CopyIcon textToCopy={supportUser?.Email} />
            </div>
            <div class="contact-item">
              <span class="contact-label">Support Email :</span>
              <a href="mailto:support@blazeo.com">support@blazeo.com</a>
              <CopyIcon textToCopy={'support@blazeo.com'} />
            </div>
          </>
        ) : (
          <p>
            <span>
              <strong>Support Email : </strong>
            </span>
            <a href="mailto:support@blazeo.com">support@blazeo.com </a>
            <CopyIcon textToCopy={'support@blazeo.com'} />
          </p>
        )}
      </div>
    </UniversalModal>
  );
};

export default ContactModal;
